export default "__VITE_ASSET__D1ikH3gv__"